import React, { FC } from 'react'
import s from './ServicesInfoSection.module.scss'
import { ReactComponent as IconSectionServices } from './../../../assets/icons/IconSectionServices.svg'
import { ReactComponent as AboutSectionRightIcon } from './../../../assets/icons/PageProductsIcons/AboutSectionRightIcon.svg'
import { ReactComponent as Rectangle } from './../../../assets/icons/PageProductsIcons/Rectangle.svg'
import { BACKEND_URL } from '../../../api'
import { IProject } from '../../../store/types'
import ProjectExamples from '../ProjectExamples/ProjectExamples'

interface ServicesInfoSectionProps {
    // About props
    icon?: string
    section_title_h1?:string
    section_description?:string

    section2_title_h1?:string
    section2_description?:string

    data: IProject[]

    
}

const ServicesInfoSection: FC<ServicesInfoSectionProps> = ({ 
    icon,
    section_title_h1,
    section_description,
    section2_title_h1,
    section2_description,
    data
}) => {

    return (
        <section className={s.section} >
            
            <Rectangle className={s.Rectangle}/>
            {section_title_h1 && 
            <div className={`${s.container} container`}>
                {/* About Block */}
                    <div className={s.aboutBlock} style={{ overflow: data.length > 0 ? 'visible' : 'hidden' }}>
                        <div className={s.box_img}>
                            <div className={s.boxiconLeft}>
                                <IconSectionServices className={s.iconLeft} />
                                {icon && 
                                <img  className={s.icon} src={BACKEND_URL + icon} alt="icon" />
                                }
                            </div>
                            <AboutSectionRightIcon className={s.iconRight} />
                        </div>
                        <div className={s.content}>
                            <h2 className='title'><span/>{section_title_h1}</h2>
                            <article>{section_description}</article>
                        </div>
                    </div>
                   
            </div>
            }
            < div className={s.featuresBlock}>
               <div className={`${s.container} container`}>
                        <h2 className='title'><span/>{section2_title_h1}</h2>
                            <p className={s.description}>{section2_description}</p>
                    </div>
                    <ProjectExamples
                 data={data || []}
                />
                </div>
                <div className={`${s.shapeRight}`} />
                <span className={`${s.gradientLine} lineGradient bottom-line`} />
        </section>
    )
}

export default ServicesInfoSection

